export class MatterDate {
  id: number;
  matter_id: number;
  matter_date_type_id: number;
  date_of: any;
  matter_user_type_name: string;
  editing: boolean = false;
  deleting: boolean = false;
  matter_date_type_name: string;
}
